import * as React from "react"
import type { IconProps } from "../types"

const CrossCircle = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 9L9 15M15 15L9 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        />
      </svg>
    )
  }
)
CrossCircle.displayName = "CrossCircle"

export default CrossCircle
